/* V3 browser-QA media behaviour. Desktop autoplay; mobile tap-to-play. */
document.addEventListener('DOMContentLoaded',()=>{
  const v=document.querySelector('.hh-proof video');
  if(!v)return;
  const sourceUrl='https://cdn.shopify.com/videos/c/o/v/5d8c4e5f4bb7414898283c8cbd904073.mp4';
  const existing=v.querySelector('source');
  if(!existing || existing.getAttribute('src')!==sourceUrl){
    v.innerHTML='';
    const s=document.createElement('source');
    s.src=sourceUrl;
    s.type='video/mp4';
    v.appendChild(s);
    v.load();
  }
  const mobile=window.matchMedia('(max-width:650px)');
  const applyMode=()=>{
    v.playsInline=true;
    v.preload='metadata';
    if(mobile.matches){
      v.autoplay=false;
      v.loop=false;
      v.controls=true;
      v.pause();
      return;
    }
    v.muted=true;
    v.defaultMuted=true;
    v.loop=true;
    v.autoplay=true;
    v.controls=false;
    v.preload='auto';
    const start=()=>{
      const p=v.play();
      if(p&&typeof p.catch==='function')p.catch(()=>{v.controls=true;});
    };
    if(v.readyState>=2)start();
    else v.addEventListener('canplay',start,{once:true});
  };
  applyMode();
  if(mobile.addEventListener)mobile.addEventListener('change',applyMode);
});
